import FileName from '../ComControl/FileName'
import Viewport from '../ComControl/Viewport'
import OafDetail from '../Oaf/OafDetail'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import GoodsLimiteDetailPageModel from './GoodsLimiteDetailPageModel'
import GoodsLimite from './GoodsLimite'
import FontProperty from '../MallNewClass/FontProperty'
import type { Screen_hash } from '../MallNewClass/GameMallNewModel'
import { FileReader, FileWriter } from '@/platform'

class GameMallLimiteModel {
    public Version: number = 4 // 数据版本
    // 商城背景图片
    public MallBack: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城\\商城背景.png' })

    // 装饰图层
    // public DecorateBack: FileName = new FileName(FileName.DEF_TYPE, '商城\\商城_立绘.png')
    public DecorateBack: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' })

    public Decorate_X: number = 0 // 装饰图层X坐标
    public Decorate_Y: number = 0 // 装饰图层Y坐标
    public IsUseOaf: boolean = false // 是否使用动图
    public OafDetailInfo: OafDetail = new OafDetail() // 动图信息
    public ClosePic: AvgButtonIndex = new AvgButtonIndex() // 关闭按钮图片
    public GoodsDetailPage: GoodsLimiteDetailPageModel = new GoodsLimiteDetailPageModel() // 商品详情页信息
    public GoodsAreaBack: FileName = new FileName({ type: FileName.DEF_TYPE, name: '' }) // 商品区域底板图
    public IsShowGoodsName: boolean = true // 是否显示商品名称
    public IsShowGoodsIntro: boolean = true // 是否显示商品简介
    public IsShowGoodsImage: boolean = true // 是否显示商品图片
    public IsShowGoodsCount: boolean = true // 是否显示售卖数量
    public GoodsList: Array<GoodsLimite> = [] // 商品列表
    public FlowerFont: FontProperty = new FontProperty() // 剩余鲜花字体属性
    public FlowerPic: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城_花.png' }) // 鲜花图片
    public Flower_X: number = 0 // 鲜花X坐标
    public Flower_Y: number = 0 // 鲜花Y坐标
    public FlowerOwn_X: number = 0 // 剩余鲜花X坐标
    public FlowerOwn_Y: number = 0 // 剩余鲜花Y坐标
    public FlowerPrice_X: number = 0 // 剩余鲜花数X坐标
    public FlowerPrice_Y: number = 0 // 剩余鲜花数Y坐标
    public GoodsAreaBack_X: number = 0 // 商品区域底板X坐标
    public GoodsAreaBack_Y: number = 0 // 商品区域底板Y坐标
    public GoodsAreaBack_W: number = 1 // 商品区域底板宽度
    public GoodsAreaBack_H: number = 1 // 商品区域底板高度
    public PrePic: AvgButtonIndex = new AvgButtonIndex() // 前翻按钮
    public NextPic: AvgButtonIndex = new AvgButtonIndex() // 后翻按钮
    public PageFont: FontProperty = new FontProperty() // 页码文字属性
    public PageX: number = 0 // 页码x偏移
    public PageY: number = 0 // 页码y偏移
    public LimitTime: boolean = false // 是否开启限时商城
    public TagName: string = '限时商城' // 标签名称
    public TagButton: AvgButtonIndex = new AvgButtonIndex() // 标签按钮
    public NewGoods: number = 1 // 新增商品数量
    public PublishTime: string = '0' // 发布时间
    public ModifyPosition: number = 0 // 修改来源 0=工具 1=个人中心

    private Screen_hash: Screen_hash
    private FontColor_UI: string
    private FontName: string

    // 初始化数据
    constructor(
        Screen_hash: Screen_hash = { Width: 960, Height: 540 },
        FontColor_UI: string = '255,255,255',
        FontName: string = '宋体'
    ) {
        this.Screen_hash = Screen_hash
        this.FontColor_UI = FontColor_UI
        this.FontName = FontName

        this.Decorate_X = this.GetDecorateBackX()
        this.Decorate_Y = this.GetDecorateBackY()
        this.FlowerOwn_X = this.GetRestX()
        this.FlowerOwn_Y = this.GetRestY()
        this.Flower_X = this.GetFlowerX()
        this.Flower_Y = this.GetFlowerY()
        this.FlowerFont = new FontProperty(this.FontName, 14, this.FontColor_UI)
        this.FlowerPrice_X = this.GetRestNumX()
        this.FlowerPrice_Y = this.GetRestNumY()
        // this.ClosePic = new AvgButtonIndex(39, this.GetClosePicX(), this.GetClosePicY())
        this.ClosePic = new AvgButtonIndex(15, this.GetClosePicX(), this.GetClosePicY())
        this.GoodsDetailPage = this.GreateDetailPageModel()
        this.GoodsAreaBack_X = this.GetGoodsAreaBack_X()
        this.GoodsAreaBack_Y = this.GetGoodsAreaBack_Y()
        this.GoodsAreaBack_W = this.GetGoodsAreaBack_W()
        this.GoodsAreaBack_H = this.GetGoodsAreaBack_H()
        this.GoodsList = this.CreateGoods()
        this.PageFont = new FontProperty(this.FontName, 14, this.FontColor_UI)
    }

    // 获取装饰图层的初始X坐标
    private GetDecorateBackX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 698
        else if (screenW == 1280 && screenH == 720) return 937

        return 0
    }

    // 获取装饰图层的初始Y坐标
    private GetDecorateBackY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 16
        else if (screenW == 1280 && screenH == 720) return 22
        else if (screenW == 800 && screenH == 600) return 75

        return 0
    }

    // 获取关闭按钮的X坐标
    private GetClosePicX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 860
        else if (screenW == 1280 && screenH == 720) return 1140
        else if (screenW == 800 && screenH == 600) return 663
        else if (screenW == 540 && screenH == 960) return 459
        return 0
    }

    // 获取关闭按钮的Y坐标
    private GetClosePicY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 243
        else if (screenW == 1280 && screenH == 720) return 375
        else if (screenW == 800 && screenH == 600) return 504
        else if (screenW == 540 && screenH == 960) return 855
        return 0
    }

    // 获取商品区域底板X坐标
    private GetGoodsAreaBack_X(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 80
        else if (screenW == 1280 && screenH == 720) return 108
        else if (screenW == 540 && screenH == 960) return 70
        return 0
    }

    // 获取商品区域底板Y坐标
    private GetGoodsAreaBack_Y(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 152
        else if (screenW == 1280 && screenH == 720) return 230
        else if (screenW == 540 && screenH == 960) return 212
        return 0
    }

    // 获取商品区域底板X坐标
    private GetGoodsAreaBack_W(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 9
        else if (screenW == 1280 && screenH == 720) return 864
        else if (screenW == 540 && screenH == 960) return 400
        return 0
    }

    // 获取商品区域底板X坐标
    private GetGoodsAreaBack_H(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 5
        else if (screenW == 1280 && screenH == 720) return 384
        else if (screenW == 540 && screenH == 960) return 612
        return 0
    }

    // 剩余鲜花X坐标
    private GetRestX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 584
        else if (screenW == 1280 && screenH == 720) return 779
        else if (screenW == 540 && screenH == 960) return 322
        return 0
    }

    // 剩余鲜花Y坐标
    private GetRestY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 123
        else if (screenW == 1280 && screenH == 720) return 190
        else if (screenW == 540 && screenH == 960) return 187
        return 0
    }

    // 鲜花X坐标
    private GetFlowerX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height
        if (screenW == 960 && screenH == 540) return 667
        else if (screenW == 1280 && screenH == 720) return 892
        else if (screenW == 540 && screenH == 960) return 407
        return 0
    }

    // 鲜花Y坐标
    private GetFlowerY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 121
        else if (screenW == 1280 && screenH == 720) return 190
        else if (screenW == 540 && screenH == 960) return 184
        return 0
    }

    // 剩余鲜花数量X坐标
    private GetRestNumX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 690
        else if (screenW == 1280 && screenH == 720) return 992
        else if (screenW == 540 && screenH == 960) return 432
        return 0
    }

    // 剩余鲜花数量Y坐标
    private GetRestNumY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 54
        else if (screenW == 1280 && screenH == 720) return 74
        else if (screenW == 540 && screenH == 960) return 184
        return 0
    }

    // 创建详情页数据
    private GreateDetailPageModel(): GoodsLimiteDetailPageModel {
        let goodsDetailPageModel: GoodsLimiteDetailPageModel = new GoodsLimiteDetailPageModel()

        goodsDetailPageModel.PreviewBack_X = this.GetPreviewBackX()
        goodsDetailPageModel.PreviewBack_Y = this.GetPreviewBackY()
        goodsDetailPageModel.PreviewBack_W = this.GetPreviewBackW()
        goodsDetailPageModel.PreviewBack_H = this.GetPreviewBackH()
        goodsDetailPageModel.Preview_X = this.GetPreviewX()
        goodsDetailPageModel.Preview_Y = this.GetPreviewY()
        goodsDetailPageModel.Preview_W = this.GetPreviewW()
        goodsDetailPageModel.Preview_H = this.GetPreviewH()
        goodsDetailPageModel.GoodsName_X = this.GetGoodsNameX()
        goodsDetailPageModel.GoodsName_Y = this.GetGoodsNameY()
        goodsDetailPageModel.FlowerTotal_X = this.GetFlowerTotalX()
        goodsDetailPageModel.FlowerTotal_Y = this.GetFlowerTotalY()
        goodsDetailPageModel.Flower_X = this.GetGoodsFlowerX()
        goodsDetailPageModel.Flower_Y = this.GetGoodsFlowerY()
        goodsDetailPageModel.GoodsPrice_X = this.GetGoodsPriceX()
        goodsDetailPageModel.GoodsPrice_Y = this.GetGoodsPriceY()
        goodsDetailPageModel.GoodsIntroView = this.GetGoodsIntroView()
        goodsDetailPageModel.Ok_btn = new AvgButtonIndex(40, this.GetOKBtnX(), this.GetOKBtnY())
        goodsDetailPageModel.Cancel_btn = new AvgButtonIndex(
            41,
            this.GetCancelBtnX(),
            this.GetCancelBtnY()
        )
        goodsDetailPageModel.Add_btn = new AvgButtonIndex(45, this.GetAddBtnX(), this.GetAddBtnY())
        goodsDetailPageModel.Minus_btn = new AvgButtonIndex(
            46,
            this.GetMinBtnX(),
            this.GetMinBtnY()
        )
        goodsDetailPageModel.BuyCount_X = this.GetBuyCountX()
        goodsDetailPageModel.BuyCount_Y = this.GetBuyCountY()
        goodsDetailPageModel.LimitTime_X = this.GetLimitTimeX()
        goodsDetailPageModel.LimitTime_Y = this.GetLimitTimeY()
        goodsDetailPageModel.SaleCount_X = this.GetSaleCountX()
        goodsDetailPageModel.SaleCount_Y = this.GetSaleCountY()

        return goodsDetailPageModel
    }

    public static ResetDetailPageModel(goodsDetailPageModel: GoodsLimiteDetailPageModel) {
        // TODO
    }

    // 获取预览图底板X坐标
    private GetPreviewBackX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 173
        else if (screenW == 1280 && screenH == 720) return 90
        else if (screenW == 540 && screenH == 960) return 178

        return 0
    }

    // 获取预览图底板Y坐标
    private GetPreviewBackY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 202
        else if (screenW == 1280 && screenH == 720) return 203
        else if (screenW == 540 && screenH == 960) return 217

        return 0
    }

    // 获取预览图底板宽
    private GetPreviewBackW(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 95
        else if (screenW == 1280 && screenH == 720) return 233
        else if (screenW == 540 && screenH == 960) return 175

        return 0
    }

    // 获取预览图底板高
    private GetPreviewBackH(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 96
        else if (screenW == 1280 && screenH == 720) return 244
        else if (screenW == 540 && screenH == 960) return 185

        return 0
    }

    // 获取预览图X坐标
    private GetPreviewX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 404
        else if (screenW == 1280 && screenH == 720) return 116
        else if (screenW == 540 && screenH == 960) return 204

        return 0
    }

    // 获取预览图Y坐标
    private GetPreviewY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 204
        else if (screenW == 1280 && screenH == 720) return 245
        else if (screenW == 540 && screenH == 960) return 247

        return 0
    }

    // 获取预览图宽度
    private GetPreviewW(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 120
        else if (screenW == 1280 && screenH == 720) return 164
        else if (screenW == 540 && screenH == 960) return 123

        return 0
    }

    // 获取预览图高度
    private GetPreviewH(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 120
        else if (screenW == 1280 && screenH == 720) return 164
        else if (screenW == 540 && screenH == 960) return 123

        return 0
    }

    // 获取商品名称X坐标
    private GetGoodsNameX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 347
        else if (screenW == 1280 && screenH == 720) return 587
        else if (screenW == 540 && screenH == 960) return 214

        return 0
    }

    // 获取商品名称Y坐标
    private GetGoodsNameY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 163
        else if (screenW == 1280 && screenH == 720) return 203
        else if (screenW == 540 && screenH == 960) return 307

        return 0
    }

    // 获取商品详情价格总共字符串的X坐标
    private GetFlowerTotalX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 408
        else if (screenW == 1280 && screenH == 720) return 666
        else if (screenW == 540 && screenH == 960) return 211

        return 0
    }

    // 获取商品详情价格总共字符串的Y坐标
    private GetFlowerTotalY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 320
        else if (screenW == 1280 && screenH == 720) return 408
        else if (screenW == 540 && screenH == 960) return 341

        return 0
    }

    // 获取商品详情价格鲜花X坐标
    private GetGoodsFlowerX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 468
        else if (screenW == 1280 && screenH == 720) return 726
        else if (screenW == 540 && screenH == 960) return 270

        return 0
    }

    // 获取商品详情价格鲜花Y坐标
    private GetGoodsFlowerY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 318
        else if (screenW == 1280 && screenH == 720) return 405
        else if (screenW == 540 && screenH == 960) return 339

        return 0
    }

    // 获取商品价格X坐标
    private GetGoodsPriceX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 488
        else if (screenW == 1280 && screenH == 720) return 751
        else if (screenW == 540 && screenH == 960) return 295

        return 0
    }

    // 获取商品价格Y坐标
    private GetGoodsPriceY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 320
        else if (screenW == 1280 && screenH == 720) return 408
        else if (screenW == 540 && screenH == 960) return 341

        return 0
    }

    // 获取商品简介尺寸
    private GetGoodsIntroView(): Viewport {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return new Viewport(347, 219, 227, 36)
        else if (screenW == 1280 && screenH == 720) return new Viewport(437, 268, 401, 48)
        else if (screenW == 540 && screenH == 960) return new Viewport(158, 379, 227, 63)

        return new Viewport(0, 0, 0, 0)
    }

    // 获取商品详情页购买数量的X坐标
    private GetBuyCountX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 410
        else if (screenW == 1280 && screenH == 720) return 561
        else if (screenW == 540 && screenH == 960) return 268

        return 0
    }

    // 获取商品详情页购买数量的Y坐标
    private GetBuyCountY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 222
        else if (screenW == 1280 && screenH == 720) return 465
        else if (screenW == 540 && screenH == 960) return 511

        return 0
    }

    // 获取确定按钮的位置X
    private GetOKBtnX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 469
        else if (screenW == 1280 && screenH == 720) return 454
        else if (screenW == 540 && screenH == 960) return 195

        return 0
    }

    // 获取确定按钮的位置Y
    private GetOKBtnY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 411
        else if (screenW == 1280 && screenH == 720) return 564
        else if (screenW == 540 && screenH == 960) return 565

        return 0
    }

    // 获取取消按钮的位置X
    private GetCancelBtnX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 332
        else if (screenW == 1280 && screenH == 720) return 645
        else if (screenW == 540 && screenH == 960) return 195

        return 0
    }

    // 获取取消按钮的位置X
    private GetCancelBtnY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 411
        else if (screenW == 1280 && screenH == 720) return 564
        else if (screenW == 540 && screenH == 960) return 622

        return 0
    }

    // 获取+按钮的位置X
    private GetAddBtnX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 450
        else if (screenW == 1280 && screenH == 720) return 601
        else if (screenW == 540 && screenH == 960) return 308

        return 0
    }

    // 获取+按钮的位置Y
    private GetAddBtnY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 223
        else if (screenW == 1280 && screenH == 720) return 466
        else if (screenW == 540 && screenH == 960) return 512

        return 0
    }

    // 获取-按钮的位置X
    private GetMinBtnX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 356
        else if (screenW == 1280 && screenH == 720) return 507
        else if (screenW == 540 && screenH == 960) return 214

        return 0
    }

    // 获取-按钮的位置Y
    private GetMinBtnY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 223
        else if (screenW == 1280 && screenH == 720) return 466
        else if (screenW == 540 && screenH == 960) return 512

        return 0
    }

    // 获取售卖时间的位置X
    private GetLimitTimeX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 347
        else if (screenW == 1280 && screenH == 720) return 511
        else if (screenW == 540 && screenH == 960) return 137

        return 0
    }

    // 获取售卖时间的位置Y
    private GetLimitTimeY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 360
        else if (screenW == 1280 && screenH == 720) return 338
        else if (screenW == 540 && screenH == 960) return 446

        return 0
    }

    // 获取售卖数量的位置X
    private GetSaleCountX(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 494
        else if (screenW == 1280 && screenH == 720) return 490
        else if (screenW == 540 && screenH == 960) return 163

        return 0
    }

    // 获取售卖数量的位置Y
    private GetSaleCountY(): number {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        if (screenW == 960 && screenH == 540) return 360
        else if (screenW == 1280 && screenH == 720) return 406
        else if (screenW == 540 && screenH == 960) return 480

        return 0
    }

    // 创建商品列表
    private CreateGoods(): GoodsLimite[] {
        let goods = new GoodsLimite(this.FontColor_UI)
        goods.GoodsId = 1001
        this.SetGoodsLocation(goods, 1, 1)

        // return [new GoodLimite()]
        return [goods]
    }

    /**
     * @description: 根据商品数量更新默认位置
     * @param {GoodLimite} goodsDetail 商品对象
     * @param {number} count 商品总数
     * @param {number} index 当前商品索引
     * @return {*}
     */
    public SetGoodsLocation(goodsDetail: GoodsLimite, count: number, index: number) {
        const screenW = this.Screen_hash.Width
        const screenH = this.Screen_hash.Height

        const getGoodsBack_X = (screenW: number, count: number, index: number): number => {
            const numsByScreen: Record<number, Record<number, Record<number, number>>> = {
                960: {
                    1: {
                        1: 281,
                    },
                    2: {
                        1: 245,
                        2: 245,
                    },
                    3: {
                        1: 266,
                        2: 266,
                        3: 266,
                    },
                    4: {
                        1: 80,
                        2: 479,
                        3: 80,
                        4: 479,
                    },
                    5: {
                        1: 101,
                        2: 490,
                        3: 101,
                        4: 490,
                        5: 101,
                    },
                },
                1280: {
                    1: {
                        1: 373,
                    },
                    2: {
                        1: 267,
                        2: 267,
                    },
                    3: {
                        1: 393,
                        2: 393,
                        3: 393,
                    },
                    4: {
                        1: 190,
                        2: 672,
                        3: 190,
                        4: 672,
                    },
                    5: {
                        1: 188,
                        2: 666,
                        3: 188,
                        4: 666,
                        5: 188,
                    },
                },
                540: {
                    1: {
                        1: 70,
                    },
                    2: {
                        1: 70,
                        2: 70,
                    },
                    3: {
                        1: 74,
                        2: 74,
                        3: 74,
                    },
                    4: {
                        1: 70,
                        2: 70,
                        3: 70,
                        4: 70,
                    },
                    5: {
                        1: 70,
                        2: 70,
                        3: 70,
                        4: 70,
                        5: 70,
                    },
                },
            }
            const nums = numsByScreen[screenW]

            if ([1, 2, 3, 4, 5].includes(count)) {
                return nums?.[count]?.[index] ?? 0
            } else {
                const num: Record<number, Record<number, number>> = {
                    960: {
                        0: 481,
                        1: 91,
                        2: 481,
                        3: 91,
                        4: 481,
                        5: 91,
                    },
                    1280: {
                        0: 666,
                        1: 188,
                        2: 666,
                        3: 188,
                        4: 666,
                        5: 188,
                    },
                    549: {
                        0: 70,
                        1: 70,
                        2: 70,
                        3: 70,
                        4: 70,
                        5: 70,
                    },
                }
                // 大于等于6个的商品求余取位
                const tag = index % 6
                return num[screenW]?.[tag] ?? 0
            }
        }

        const getGoodsBack_Y = (screenW: number, count: number, index: number): number => {
            const numsByScreen: Record<number, Record<number, Record<number, number>>> = {
                960: {
                    1: {
                        1: 191,
                    },
                    2: {
                        1: 119,
                        2: 247,
                    },
                    3: {
                        1: 102,
                        2: 231,
                        3: 326,
                    },
                    4: {
                        1: 172,
                        2: 172,
                        3: 297,
                        4: 297,
                    },
                    5: {
                        1: 112,
                        2: 112,
                        3: 229,
                        4: 229,
                        5: 346,
                    },
                },
                1280: {
                    1: {
                        1: 270,
                    },
                    2: {
                        1: 208,
                        2: 370,
                    },
                    3: {
                        1: 153,
                        2: 305,
                        3: 457,
                    },
                    4: {
                        1: 188,
                        2: 188,
                        3: 347,
                        4: 347,
                    },
                    5: {
                        1: 144,
                        2: 144,
                        3: 297,
                        4: 297,
                        5: 450,
                    },
                },
                540: {
                    1: {
                        1: 212,
                    },
                    2: {
                        1: 212,
                        2: 512,
                    },
                    3: {
                        1: 235,
                        2: 435,
                        3: 635,
                    },
                    4: {
                        1: 209,
                        2: 359,
                        3: 509,
                        4: 659,
                    },
                    5: {
                        1: 212,
                        2: 332,
                        3: 452,
                        4: 572,
                        5: 692,
                    },
                },
            }
            const nums = numsByScreen[screenW]

            if ([1, 2, 3, 4, 5].includes(count)) {
                return nums?.[count]?.[index] ?? 0
            } else {
                const num: Record<number, Record<number, number>> = {
                    960: {
                        0: 104,
                        1: 104,
                        2: 228,
                        3: 228,
                        4: 352,
                        5: 352,
                    },
                    1280: {
                        0: 450,
                        1: 144,
                        2: 144,
                        3: 297,
                        4: 297,
                        5: 450,
                    },
                    549: {
                        0: 212,
                        1: 312,
                        2: 412,
                        3: 512,
                        4: 612,
                        5: 712,
                    },
                }
                // 大于等于6个的商品求余取位
                const tag = index % 6
                return num[screenW]?.[tag] ?? 0
            }
        }

        const getGoodsBack_W = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 371
                    break
                case 1260:
                    return 457
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [400, 400, 400, 400, 400]
                        return nums[count - 1]
                    } else {
                        return 397
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getGoodsBack_H = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 104
                    break
                case 1260:
                    return 134
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [608, 296, 151, 152, 107]
                        return nums[count - 1]
                    } else {
                        return 92
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getBuyBtn_X = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 273
                    break
                case 1260:
                    return 332
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [154, 288, 280, 276, 282]
                        return nums[count - 1]
                    } else {
                        return 292
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getBuyBtn_Y = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 4
                    break
                case 1260:
                    return 6
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [540, 238, 21, 22, 20]
                        return nums[count - 1]
                    } else {
                        return 12
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getFlower_X = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 116
                    break
                case 1260:
                    return 217
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [137, 226, 161, 146, 128]
                        return nums[count - 1]
                    } else {
                        return 115
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getFlower_Y = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 42
                    break
                case 1260:
                    return 61
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [459, 202, 61, 57, 46]
                        return nums[count - 1]
                    } else {
                        return 35
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getGoodsName_X = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 116
                    break
                case 1260:
                    return 205
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [139, 108, 161, 146, 128]
                        return nums[count - 1]
                    } else {
                        return 116
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getGoodsName_Y = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 5
                    break
                case 1260:
                    return 20
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [424, 196, 21, 16, 11]
                        return nums[count - 1]
                    } else {
                        return 4
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getGoodsPrice_X = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 137
                    break
                case 1260:
                    return 248
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [160, 249, 183, 169, 151]
                        return nums[count - 1]
                    } else {
                        return 136
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getGoodsPrice_Y = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 43
                    break
                case 1260:
                    return 62
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [460, 203, 62, 58, 47]
                        return nums[count - 1]
                    } else {
                        return 36
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreviewBack_X = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 4
                    break
                case 1260:
                    return 4
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [4, 126, 4, 6, 4]
                        return nums[count - 1]
                    } else {
                        return 4
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreviewBack_Y = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 4
                    break
                case 1260:
                    return 4
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [4, 15, 4, 15, 4]
                        return nums[count - 1]
                    } else {
                        return 4
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreviewBack_W = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 96
                    break
                case 1260:
                    return 126
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [392, 158, 124, 108, 104]
                        return nums[count - 1]
                    } else {
                        return 16
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreviewBack_H = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 96
                    break
                case 1260:
                    return 126
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [392, 160, 126, 112, 100]
                        return nums[count - 1]
                    } else {
                        return 13
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreview_X = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 16
                    break
                case 1260:
                    return 20
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [50, 128, 0, 2, 16]
                        return nums[count - 1]
                    } else {
                        return 13
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreview_Y = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 16
                    break
                case 1260:
                    return 20
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [50, 26, 9, 17, 18]
                        return nums[count - 1]
                    } else {
                        return 10
                    }
                    break
                default:
                    return 0
                    break
            }
        }
        const getPreview_W = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 72
                    break
                case 1260:
                    return 90
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [300, 144, 120, 108, 72]
                        return nums[count - 1]
                    } else {
                        return 72
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getPreview_H = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 72
                    break
                case 1260:
                    return 90
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [300, 144, 120, 108, 72]
                        return nums[count - 1]
                    } else {
                        return 72
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getSalesX = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 116
                    break
                case 1260:
                    return 153
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [79, 79, 156, 146, 128]
                        return nums[count - 1]
                    } else {
                        return 116
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        const getSalesY = (screenW: number, count: number, index: number) => {
            switch (screenW) {
                case 960:
                    return 76
                    break
                case 1260:
                    return 100
                    break
                case 540:
                    if ([1, 2, 3, 4, 5].includes(count)) {
                        const nums = [496, 496, 101, 93, 70]
                        return nums[count - 1]
                    } else {
                        return 58
                    }
                    break
                default:
                    return 0
                    break
            }
        }

        goodsDetail.GoodsBack_X = getGoodsBack_X(screenW, count, index)
        goodsDetail.GoodsBack_Y = getGoodsBack_Y(screenW, count, index)
        goodsDetail.GoodsBack_W = getGoodsBack_W(screenW, count, index)
        goodsDetail.GoodsBack_H = getGoodsBack_H(screenW, count, index)
        goodsDetail.BuyBtn.X = getBuyBtn_X(screenW, count, index)
        goodsDetail.BuyBtn.Y = getBuyBtn_Y(screenW, count, index)
        goodsDetail.Flower_X = getFlower_X(screenW, count, index)
        goodsDetail.Flower_Y = getFlower_Y(screenW, count, index)
        goodsDetail.GoodsName_X = getGoodsName_X(screenW, count, index)
        goodsDetail.GoodsName_Y = getGoodsName_Y(screenW, count, index)
        goodsDetail.GoodsPrice_X = getGoodsPrice_X(screenW, count, index)
        goodsDetail.GoodsPrice_Y = getGoodsPrice_Y(screenW, count, index)
        goodsDetail.PreviewBack_X = getPreviewBack_X(screenW, count, index)
        goodsDetail.PreviewBack_Y = getPreviewBack_Y(screenW, count, index)
        goodsDetail.PreviewBack_W = getPreviewBack_W(screenW, count, index)
        goodsDetail.PreviewBack_H = getPreviewBack_H(screenW, count, index)
        goodsDetail.Preview_X = getPreview_X(screenW, count, index)
        goodsDetail.Preview_Y = getPreview_Y(screenW, count, index)
        goodsDetail.Preview_W = getPreview_W(screenW, count, index)
        goodsDetail.Preview_H = getPreview_H(screenW, count, index)
        goodsDetail.SalesX = getSalesX(screenW, count, index)
        goodsDetail.SalesY = getSalesY(screenW, count, index)
    }

    readVersionedOui(reader: FileReader, IsUI = false): void {
        this.Version = reader.readInt()
        this.MallBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.DecorateBack.readVersionedOui(reader.readObj(reader.readInt()))
        this.Decorate_X = reader.readInt()
        this.Decorate_Y = reader.readInt()
        this.IsUseOaf = Boolean(reader.readInt())

        this.OafDetailInfo.readVersionedOui(reader.readObj(reader.readInt()))
        this.ClosePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerPic.readVersionedOui(reader.readObj(reader.readInt()))

        this.Flower_X = reader.readInt()
        this.Flower_Y = reader.readInt()
        this.FlowerOwn_X = reader.readInt()
        this.FlowerOwn_Y = reader.readInt()
        this.FlowerPrice_X = reader.readInt()
        this.FlowerPrice_Y = reader.readInt()

        this.GoodsDetailPage.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsAreaBack.readVersionedOui(reader.readObj(reader.readInt()))

        this.GoodsAreaBack_X = reader.readInt()
        this.GoodsAreaBack_Y = reader.readInt()
        this.GoodsAreaBack_W = reader.readInt()
        this.GoodsAreaBack_H = reader.readInt()

        this.IsShowGoodsName = Boolean(reader.readInt())
        this.IsShowGoodsIntro = Boolean(reader.readInt())
        this.IsShowGoodsImage = Boolean(reader.readInt())

        this.PrePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.NextPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.PageFont.readVersionedOui(reader.readObj(reader.readInt()))

        this.PageX = reader.readInt()
        this.PageY = reader.readInt()

        this.LimitTime = Boolean(reader.readInt())
        this.TagName = reader.readString()

        this.TagButton.readVersionedOui(reader.readObj(reader.readInt()))

        if (!IsUI) {
            this.NewGoods = reader.readInt()
            let goodCount = 0

            try {
                goodCount = reader.readInt()
                this.GoodsList = []

                for (let i = 0; i < goodCount; i++) {
                    const goodLimite = new GoodsLimite(this.FontColor_UI)
                    goodLimite.readVersionedOui(reader.readObj(reader.readInt()))
                    this.GoodsList.push(goodLimite)
                }
            } catch {
                this.GoodsList = [new GoodsLimite(this.FontColor_UI)]
            }
        } else {
            // 新建oui2时写入了0
            reader.readInt()
        }

        if (!reader.isReadEnd()) {
            this.IsShowGoodsCount = Boolean(reader.readInt())
        }

        if (!IsUI) {
            let cnt = 0
            if (!reader.isReadEnd()) {
                cnt = reader.readInt()
            }

            for (let i = 0; i < this.GoodsList.length; i++) {
                if (!reader.isReadEnd() && i < cnt) {
                    this.GoodsList[i].GoodsPricePakoras = reader.readInt()
                } else {
                    this.GoodsList[i].GoodsPricePakoras = 0
                }
            }

            if (!reader.isReadEnd()) {
                this.PublishTime = reader.readString()
            }

            if (!reader.isReadEnd()) {
                this.ModifyPosition = reader.readInt()
            }
        } else {
            if (!reader.isReadEnd()) {
                reader.readInt()
            }
        }
    }

    writeVersionedOui(writer: FileWriter, IsUI = false): void {
        writer.writeInt(this.Version)

        this.MallBack.writeVersionedOui(writer)
        this.DecorateBack.writeVersionedOui(writer)
        writer.writeInt(this.Decorate_X)
        writer.writeInt(this.Decorate_Y)
        writer.writeInt(this.IsUseOaf ? 1 : 0)

        this.OafDetailInfo.writeVersionedOui(writer)
        this.ClosePic.writeVersionedOui(writer)
        this.FlowerFont.writeVersionedOui(writer)
        this.FlowerPic.writeVersionedOui(writer)

        writer.writeInt(this.Flower_X)
        writer.writeInt(this.Flower_Y)
        writer.writeInt(this.FlowerOwn_X)
        writer.writeInt(this.FlowerOwn_Y)
        writer.writeInt(this.FlowerPrice_X)
        writer.writeInt(this.FlowerPrice_Y)

        this.GoodsDetailPage.writeVersionedOui(writer)
        this.GoodsAreaBack.writeVersionedOui(writer)

        writer.writeInt(this.GoodsAreaBack_X)
        writer.writeInt(this.GoodsAreaBack_Y)
        writer.writeInt(this.GoodsAreaBack_W)
        writer.writeInt(this.GoodsAreaBack_H)

        writer.writeInt(this.IsShowGoodsName ? 1 : 0)
        writer.writeInt(this.IsShowGoodsIntro ? 1 : 0)
        writer.writeInt(this.IsShowGoodsImage ? 1 : 0)

        this.PrePic.writeVersionedOui(writer)
        this.NextPic.writeVersionedOui(writer)
        this.PageFont.writeVersionedOui(writer)

        writer.writeInt(this.PageX)
        writer.writeInt(this.PageY)

        writer.writeInt(this.LimitTime ? 1 : 0)
        writer.writeString(this.TagName)

        this.TagButton.writeVersionedOui(writer)

        if (!IsUI && this.GoodsList.length > 0) {
            writer.writeInt(this.NewGoods)

            writer.writeInt(this.GoodsList.length)
            for (let i = 0; i < this.GoodsList.length; i++) {
                const goods = this.GoodsList[i]
                goods.writeVersionedOui(writer)
            }
        } else {
            writer.writeInt(0)
        }

        writer.writeInt(this.IsShowGoodsCount ? 1 : 0)

        if (!IsUI && this.GoodsList.length > 0) {
            writer.writeInt(this.GoodsList.length)
            for (let i = 0; i < this.GoodsList.length; i++) {
                writer.writeInt(this.GoodsList[i].GoodsPricePakoras)
            }
            writer.writeString(this.PublishTime)
            writer.writeInt(this.ModifyPosition)
        } else {
            writer.writeInt(0)
        }
    }
}
export default GameMallLimiteModel
